import {useQuery, UseQueryResult} from '@tanstack/react-query'
import {EventTransactions} from '../OrderManager/types'
import {fetchResponse} from './utils'

export const useEventTransactionData = (
  eventId: number,
  userId: number | undefined | null,
): UseQueryResult<EventTransactions, unknown> => {
  return useQuery(
    ['eventTransactionData', eventId, userId],
    async () => {
      return fetchResponse(`/events/${eventId}/users/${userId}/transactions`)
    },
    {enabled: !!userId},
  )
}
